import $ from 'domtastic'




/* MENU
----------------------------------------------------------------------------------------------------*/

export default class Menu {

    constructor() {
        this.isOpen = false
        this.activeEvent = APP.Browser.supports.passive ? { passive: false } : false


        this.$els = {
            body       : $('body'),
            header     : $('#header'),
            btn        : $('.menu-btn'),
            scrollArea : $('.header__scrollarea'),
        }


        this.clickHandler          = (e) => { this.onButtonClick(e) }
        this.pageWillChangeHandler = () => { this.onPageWillChange() }
        this.pageChangeEndHandler  = () => { this.onPageChangeEnd() }
        this.resizeHandler         = () => { this.onResize() }
        this.scrollHandler         = () => { this.onScroll() }

        this.touchStartHandler = (e) => { this.onTouchStart(e) }
        this.touchMoveHandler  = (e) => { this.onTouchMove(e) }
        this.wheelHandler      = (e) => { this.onWheel(e) }

        this.bindEvents()
    }


    bindEvents() {
        // Nav events
        $(document).on('pageWillChange', this.pageWillChangeHandler)
        $(document).on('pageChangeEnd', this.pageChangeEndHandler)

        // Layout events
        $(document).on('layoutChange', this.resizeHandler)

        // User input
        this.$els.btn.on('click', this.clickHandler)
    }




    /* Handlers
    --------------------------------------------------------- */

    onPageWillChange() {
        //
    }


    onPageChangeEnd() {
        this.forceCloseMenu()
    }


    onResize() {
        if (!this.isOpen || APP.Layout.isMobile) return

        this.forceCloseMenu()
    }


    onScroll() {
        //
    }


    onButtonClick(e) {
        e.preventDefault()

        this.toggleMenu()
    }


    onTouchStart(e) {
        if (e.targetTouches.length === 1) {
            this.startTouchY = e.targetTouches[0].clientY
        }
    }


    onTouchMove(e) {
        e.stopPropagation()

        const o   = this.currOverlay
        const oH  = o.clientHeight
        const oSH = o.scrollHeight
        const oST = o.scrollTop

        const moveY = e.targetTouches[0].clientY - this.startTouchY
        const isOverlayScrolled = oSH - oST <= oH


        if ((oST === 0 && moveY > 0) || (isOverlayScrolled && moveY < 0)) {
            e.preventDefault()
        }
    }


    onWheel(e) {
        e.stopPropagation()

        const o   = this.currOverlay
        const oH  = o.clientHeight
        const oSH = o.scrollHeight
        const oST = o.scrollTop

        const isOverlayScrolled = oSH - oST <= oH

        if ((oST === 0 && e.deltaY < 0) || (isOverlayScrolled && e.deltaY > 0)) {
            e.preventDefault()
        }
    }



    /* Actions
    --------------------------------------------------------- */

    toggleMenu(shouldOpen) {
        this.isOpen      = (typeof shouldOpen !== 'undefined') ? shouldOpen : !this.isOpen
        this.currOverlay = (this.isOpen) ? this.$els.scrollArea[0] : null

        this.$els.body.toggleClass('menu-open', this.isOpen)

        if (this.isOpen) {
            this.startTouchMovePrevention()
        } else {
            this.endTouchMovePrevention()
        }


        $(document).trigger('menuToggled', { open : this.isOpen })
    }


    forceCloseMenu() {
        this.toggleMenu(false)
    }


    startTouchMovePrevention() {
        this.$els.scrollArea[0].addEventListener('touchstart', this.touchStartHandler)
        this.$els.scrollArea[0].addEventListener('touchmove', this.touchMoveHandler, this.activeEvent)
        this.$els.scrollArea[0].addEventListener('wheel', this.wheelHandler, this.activeEvent)
    }


    endTouchMovePrevention() {
        this.$els.scrollArea[0].removeEventListener('touchstart', this.touchStartHandler)
        this.$els.scrollArea[0].removeEventListener('touchmove', this.touchMoveHandler)
        this.$els.scrollArea[0].removeEventListener('wheel', this.wheelHandler)
    }




    /* Values
    --------------------------------------------------------- */

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



